module.exports = __webpack_public_path__ + "img/portada11.e76fb20c.svg";